import { useMutation, useQuery } from 'react-query'
import { ADD_DETAILS_URL, AVAILABLE_MODELS_URL, AVAILABLE_URL, BRANDS_URL, COLORS_URL, DELIVER_URL, EXPORT_URL, GUARANTEES_PARTS_INFO_URL, INSERT_URL, INVENTORY_URL, MODELS_URL, PARTS_URL } from '../requests/urls';
import client from './axios-client'
import { AVAILABLE_MODELS_KEY, AVAILABLE_STATUS_KEY, BRANDS_KEY, COLOR_KEY, GUARANTEES_PART_INFO_KEY, INVENTORY_STATUS_KEY, MODELS_KEY, PARTS_KEY } from './cache-keys';


export const useGetGuarantees = () => useQuery(GUARANTEES_PART_INFO_KEY(), () => client.get(GUARANTEES_PARTS_INFO_URL), { placeholderData: [] })
export const useGetParts = () => useQuery(PARTS_KEY(), () => client.get(PARTS_URL), { placeholderData: [] })
export const useCreatePart = () => useMutation(({ imeiRecords, guarantee }) => {
    const formData = new FormData();

    formData.append('imeiRecords', imeiRecords);
    formData.append('guarantee', guarantee);

    return client.post(PARTS_URL, formData)
})


export const useGetInventoryStatus = () => useQuery(INVENTORY_STATUS_KEY(), () => client.get(INVENTORY_URL), { placeholderData: [] })
export const useGetAvailableModels = (owner) => useQuery(AVAILABLE_MODELS_KEY(owner), () => client.get(AVAILABLE_MODELS_URL + `/${owner}`), { placeholderData: [] })
export const useGetAvailable = () => useQuery(INVENTORY_STATUS_KEY(), () => client.get(INVENTORY_URL), { placeholderData: [] })
export const useGetCount = (m, c, o) => useQuery(AVAILABLE_STATUS_KEY(), () => {
    console.log(m, c, o);
    return client.get(AVAILABLE_URL + `?model=${m}&color=${c}&owner=${o}`)
}, { placeholderData: 0 })
export const useGetBrands = () => useQuery(BRANDS_KEY(), () => client.get(BRANDS_URL), { placeholderData: [] })
export const useGetColors = () => useQuery(COLOR_KEY(), () => client.get(COLORS_URL), { placeholderData: [] })
export const useGetModels = () => useQuery(MODELS_KEY(), () => client.get(MODELS_URL), { placeholderData: [] })

export const useSubmitDeviceList = () => useMutation(({ ownerId, records }) => {
    const formData = new FormData();
    formData.append('records', records);
    formData.append('ownerId', ownerId);
    return client.post(INSERT_URL, formData)
})

export const useAddDeviceDetails = () => useMutation(({ imei1, modelId, colorId }) => {
    return client.put(ADD_DETAILS_URL, { imei1, modelId, colorId })
})


export const useCreateModel = () => useMutation(({ name, ram, memory, brandId }) => {
    return client.post(MODELS_URL, { name, ram, memory, brandId })
})


export const useCreateColor = () => useMutation(({ name, rgb }) => {
    return client.post(COLORS_URL, { name, rgb })
})

export const useCreateBrand = () => useMutation(({ name }) => {
    return client.post(BRANDS_URL, { name })
})

export const useExportDevice = () => useMutation(({ rowId, imei }) => {
    return client.post(EXPORT_URL, { rowId, imei })
})

export const useDeliverInvoice = (id) => useMutation(() => {
    return client.post(DELIVER_URL + `/${id}`)
})
